import {
  parseUsageData,
  parseUsageDataByDay,
  parseResultsData,
  parseAnalysisStyleData,
  parseNeuroDevData,
  parseAnalysisData,
  parseMetacognitiveData,
  parseResultsDataGrouped,
  tickVerticalGroup,
  tickHorizontalGroup,
  convertHoursToTime,
} from '@dashboard/util';
import * as moment from 'moment';

export const DATE_FILTER_WEEK = 'DATE_FILTER_WEEK';
export const DATE_FILTER_FORTNIGHT = 'DATE_FILTER_FORTNIGHT';

export const DATE_FILTER_MONTH = 'DATE_FILTER_MONTH';
export const DATE_FILTER_3_MONTHS = 'DATE_FILTER_3_MONTHS';
export const DATE_FILTER_6_MONTHS = 'DATE_FILTER_6_MONTHS';
export const DATE_FILTER_9_MONTHS = 'DATE_FILTER_9_MONTHS';
export const DATE_FILTER_12_MONTHS = 'DATE_FILTER_12_MONTHS';
export const DATE_FILTER_CUSTOM = 'DATE_FILTER_CUSTOM';

export const MIN_DAYS = 7;
export const MAX_DAYS = 365;
export const MAX_DAYS_TO_GROUP_DATA = 15;

export const CHART_FORMAT_HOURS = 'hours';
export const CHART_FORMAT_RAW = 'raw';
export const CHART_DEFAULT_STROKE_WIDTH = 2;
export const CHART_VERTICAL_LABEL_WIDTH = 200;

export const daysOfWeek = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const firstDayOfWeek = 'monday';
export const lastDayOfWeek = 'sunday';

export const DATE_FILTERS = [
  { label: 'optionLast7Days', value: DATE_FILTER_WEEK, days: MIN_DAYS },
  { label: 'optionLast15Days', value: DATE_FILTER_FORTNIGHT, days: 15 },
  { label: 'optionLast30Days', value: DATE_FILTER_MONTH, days: 30 },
  { label: 'optionLast3Months', value: DATE_FILTER_3_MONTHS, months: 3 },
  { label: 'optionLast6Months', value: DATE_FILTER_6_MONTHS, months: 6 },
  { label: 'optionLast9Months', value: DATE_FILTER_9_MONTHS, months: 9 },
  { label: 'optionLast12Months', value: DATE_FILTER_12_MONTHS, months: 12 },
  {
    label: 'optionCustomDate',
    value: DATE_FILTER_CUSTOM,
    days: -1,
    maxDays: MAX_DAYS,
  },
];

export const CHART_CURSOR_COLOR = '#eee';
export const CHART_GLOBAL_AXIS_INTERVAL = 0;
export const CHART_GLOBAL_ALLOW_DECIMALS = false;

export const CHARTS_BOUNDS = {
  width: 800,
  height: 600,
  legend_height: 40,
  margin: {
    top: 15,
    right: 20,
    left: 20,
    bottom: 30,
  },
  x_axis_angle: -45,
  y_axis_angle: -90,
  x_axis_label_angle: 0,
  y_axis_dx: -20,
  x_axis_dy: 30,
};

export const CHARTS_TYPES = {};

export const CHART_CLASS = {
  teachersUsageTime: {
    translation: 'dashboard\\ChartUsage',
    x_axis: [
      {
        dataKey: 'date',
      },
    ],
    y_axis: [
      {
        tickFormatter: (value) => `${value} h`,
        interval: 1,
        allowDecimals: false,
        label: { value: 'yAxisLabel' },
      },
    ],
    y_keys: [{ label: 'time', stroke: '#4285f4' }],
    parse: parseUsageData,
    subparse: (value) => {
      return value / 60 / 60;
    },
    tooltipFormatter: (value) => {
      return convertHoursToTime(value);
    },
    type: 'monotone',
  },
  studentsUsageTimeByPhases: {
    translation: 'dashboard\\ChartUsage',
    x_axis: [
      {
        dataKey: 'date',
      },
    ],
    y_axis: [
      {
        tickFormatter: (value) => `${value} h`,
        interval: 1,
        allowDecimals: false,
        label: { value: 'yAxisLabelTime' },
      },
    ],
    y_keys: [
      { label: 'newContents', color: '#ababab', stackId: 'a' },
      { label: 'solve', color: '#ea3c36', stackId: 'a' },
      { label: 'improve', color: '#38b27b', stackId: 'a' },
      { label: 'difficulty', color: '#8c0500', stackId: 'a' },
    ],
    parse: parseUsageData,
    subparse: (value) => {
      return parseFloat(value / 60 / 60);
    },
    tooltipFormatter: (value) => {
      return convertHoursToTime(parseFloat(value));
    },
  },
  teachersAccessCount: {
    translation: 'dashboard\\ChartUsage',
    x_axis: [
      {
        dataKey: 'date',
      },
    ],
    y_axis: [
      {
        interval: 1,
        allowDecimals: false,
        label: { value: 'countLabelTeacher' },
      },
    ],
    y_keys: [{ label: 'countTeacher', stroke: '#4285f4' }],
    format: CHART_FORMAT_RAW,
    parse: parseUsageData,
    type: 'monotone',
  },
  studentsAccessCount: {
    translation: 'dashboard\\ChartUsage',
    yAxisLabel: 'countLabelStudent',
    x_axis: [
      {
        dataKey: 'date',
      },
    ],
    y_axis: [
      {
        label: { value: 'countLabelStudent' },
        interval: 1,
        allowDecimals: false,
      },
    ],
    y_keys: [{ label: 'countStudent', stroke: '#4285f4' }],
    format: CHART_FORMAT_RAW,
    parse: parseUsageData,
    type: 'monotone',
  },
  teachersAccessHour: {
    translation: 'dashboard\\ChartUsage',
    x_axis: [
      {
        dataKey: 'time',
      },
    ],
    y_axis: [
      {
        label: { value: 'countLabel' },
        interval: 1,
        allowDecimals: false,
      },
    ],
    y_keys: [
      { label: 'monday', stroke: '#a4c2f4' },
      { label: 'tuesday', stroke: '#6d9eeb' },
      { label: 'wednesday', stroke: '#3c78d8' },
      { label: 'thursday', stroke: '#1155cc' },
      { label: 'friday', stroke: '#1c4587' },
      { label: 'saturday', stroke: '#ebb200' },
      { label: 'sunday', stroke: '#bf9000' },
    ],
    parse: parseUsageDataByDay,
    daysOfWeek,
    firstDayOfWeek,
    lastDayOfWeek,
  },
  studentsUsageTimeBySessionType: {
    translation: 'dashboard\\ChartUsage',
    x_axis: [
      {
        dataKey: 'date',
      },
    ],
    y_axis: [
      {
        tickFormatter: (value) => `${value} h`,
        interval: 1,
        allowDecimals: false,
        label: { value: 'yAxisLabelTime' },
      },
    ],
    y_keys: [
      { label: 'recommended', color: '#29cf84' },
      { label: 'directSelection', color: '#ff971e' },
    ],
    parse: parseUsageData,
    subparse: (value) => {
      return parseFloat(value / 60 / 60);
    },
    tooltipFormatter: (value) => {
      return convertHoursToTime(parseFloat(value));
    },
  },
  studentsAccessHour: {
    translation: 'dashboard\\ChartUsage',
    x_axis: [{ dataKey: 'time' }],
    y_axis: [
      {
        label: { value: 'countLabel' },
        interval: 1,
        allowDecimals: false,
      },
    ],
    y_keys: [
      { label: 'monday', stroke: '#a4c2f4' },
      { label: 'tuesday', stroke: '#6d9eeb' },
      { label: 'wednesday', stroke: '#3c78d8' },
      { label: 'thursday', stroke: '#1155cc' },
      { label: 'friday', stroke: '#1c4587' },
      { label: 'saturday', stroke: '#ebb200' },
      { label: 'sunday', stroke: '#bf9000' },
    ],
    format: CHART_FORMAT_RAW,
    parse: parseUsageDataByDay,
    daysOfWeek,
    firstDayOfWeek,
    lastDayOfWeek,
  },
  evaluationsByUnitsResults: (currentFilters) => {
    const diff = Math.abs(
      moment(currentFilters.to).diff(currentFilters.from, 'days'),
    );
    if (diff > MAX_DAYS_TO_GROUP_DATA) {
      return {
        translation: 'dashboard\\ResultsStatsView',
        x_axis: [
          {
            dataKey: 'date',
          },
        ],
        y_axis: [
          {
            label: { value: 'yAxisLabel' },
          },
        ],
        y_keys: [
          { label: 'difficulty', color: '#ea3c36', stackId: 'a' },
          { label: 'failed', color: '#ff643c', stackId: 'a' },
          { label: 'approved', color: '#41d793', stackId: 'a' },
          { label: 'perfect', color: '#029eaa', stackId: 'a' },
        ],
        parse: parseResultsDataGrouped,
      };
    }
    return {
      translation: ['dashboard\\ResultsStatsView', 'dashboard\\Publications'],
      translation_ns_parse: { ns: 'dashboard\\Publications' },
      x_axis: [
        {
          dataKey: 'unit',
          type: 'category',
          angle: -90,
          position: 'bottom',
          textAnchor: 'end',
          fontSize: 10,
          height: 205,
          tickFormatter: (value, t) => {
            return t(value, { ns: 'dashboard\\Publications' });
          },
        },
        {
          dataKey: 'metaData',
          axisLine: false,
          tickLine: false,
          height: 1,
          scale: 'band',
          xAxisId: 'unit',
          tick: (tickProps) => tickHorizontalGroup(tickProps, 205),
        },
      ],
      y_axis: [
        {
          label: { value: 'yAxisLabel' },
        },
      ],
      y_keys: [
        { label: 'difficulty', color: '#ea3c36', stackId: 'a' },
        { label: 'failed', color: '#ff643c', stackId: 'a' },
        { label: 'approved', color: '#41d793', stackId: 'a' },
        { label: 'perfect', color: '#029eaa', stackId: 'a' },
      ],
      parse: parseResultsData,
    };
  },
  firstAssignmentCognitiveStyleAnalysis: {
    translation: 'dashboard\\ChartCognitiveStyle',
    x_axis: [
      {
        dataKey: 'date',
      },
    ],
    y_axis: [
      {
        label: { value: 'yAxisLabel' },
      },
    ],
    y_keys: [
      { label: 'undetermined', color: '#434343', stackId: 'a' },
      { label: 'veryImpulsive', color: '#e95651', stackId: 'a' },
      { label: 'impulsive', color: '#e94d48', stackId: 'a' },
      { label: 'veryIneffective', color: '#ffc000', stackId: 'a' },
      { label: 'ineffective', color: '#fbcc00', stackId: 'a' },
      { label: 'reflexive', color: '#63d5a1', stackId: 'a' },
      { label: 'veryReflexive', color: '#41d793', stackId: 'a' },
      { label: 'effective', color: '#19a3ad', stackId: 'a' },
      { label: 'veryEffective', color: '#029eaa', stackId: 'a' },
    ],
    parse: parseAnalysisStyleData,
  },
  fisiologicalAgeCognitiveStyleAnalysis: {
    translation: 'dashboard\\ChartCognitiveStyle',
    x_axis: [
      {
        dataKey: 'date',
      },
    ],
    y_axis: [
      {
        label: { value: 'yAxisLabel' },
      },
    ],
    y_keys: [
      { label: 'undetermined', color: '#434343', stackId: 'a' },
      { label: 'veryImpulsive', color: '#e95651', stackId: 'a' },
      { label: 'impulsive', color: '#e94d48', stackId: 'a' },
      { label: 'veryIneffective', color: '#ffc000', stackId: 'a' },
      { label: 'ineffective', color: '#fbcc00', stackId: 'a' },
      { label: 'reflexive', color: '#63d5a1', stackId: 'a' },
      { label: 'veryReflexive', color: '#41d793', stackId: 'a' },
      { label: 'effective', color: '#19a3ad', stackId: 'a' },
      { label: 'veryEffective', color: '#029eaa', stackId: 'a' },
    ],
    parse: parseAnalysisStyleData,
  },
  firstAssignmentCompetencialNeuroDevelopmentAnalysis: {
    translation: [
      'dashboard\\ChartNeuroDevelopment',
      'dashboard\\Publications',
    ],
    translation_ns_parse: { ns: 'dashboard\\Publications' },
    xAxisLabel: 'xAxisLabel',
    horizontal: false,

    x_axis: [
      {
        label: { value: 'xAxisLabel' },
        type: 'number',
        angle: 0,
      },
    ],
    y_axis: [
      {
        type: 'category',
        width: CHART_VERTICAL_LABEL_WIDTH,
        dataKey: 'cognitiveProcess',
      },
    ],
    x_keys: [
      { label: 'underLevel', color: '#ffc000', stackId: 'a' },
      { label: 'onLevel', color: '#67c15b', stackId: 'a' },
      { label: 'overLevel', color: '#5b9bd5', stackId: 'a' },
      { label: 'undetermined', color: '#a3afbe', stackId: 'a' },
    ],
    layout: 'vertical',
    parse: parseNeuroDevData,
  },
  fisiologicalAgeCompetencialNeuroDevelopmentAnalysis: {
    translation: [
      'dashboard\\ChartNeuroDevelopment',
      'dashboard\\Publications',
    ],
    translation_ns_parse: { ns: 'dashboard\\Publications' },
    x_axis: [
      {
        label: { value: 'xAxisLabel' },
        type: 'number',
        angle: 0,
      },
    ],
    y_axis: [
      {
        type: 'category',
        width: CHART_VERTICAL_LABEL_WIDTH,
        dataKey: 'cognitiveProcess',
      },
    ],
    horizontal: false,
    x_keys: [
      { label: 'underLevel', color: '#ffc000', stackId: 'a' },
      { label: 'onLevel', color: '#67c15b', stackId: 'a' },
      { label: 'overLevel', color: '#5b9bd5', stackId: 'a' },
      { label: 'undetermined', color: '#a3afbe', stackId: 'a' },
    ],
    layout: 'vertical',
    parse: parseNeuroDevData,
  },
  firstAssignmentCalculationAndNumerationNeuropsychologicalModelAnalysis: {
    translation: [
      'dashboard\\ChartInformationProcessing',
      'dashboard\\Publications',
    ],
    translation_ns_parse: { ns: 'dashboard\\Publications' },
    x_axis: [
      {
        label: { value: 'xAxisLabel' },
        type: 'number',
        angle: 0,
      },
    ],
    y_axis: [
      {
        type: 'category',
        width: CHART_VERTICAL_LABEL_WIDTH,
        dataKey: 'subprocess',
      },
      {
        dataKey: 'metaData',
        axisLine: false,
        tickLine: false,
        type: 'category',
        yAxisId: 'process',
        interval: 'preserveStartEnd',
        fontSize: 10,
        tick: tickVerticalGroup,
      },
    ],
    horizontal: false,
    x_keys: [
      { label: 'underLevel', color: '#ffc000', stackId: 'a' },
      { label: 'onLevel', color: '#67c15b', stackId: 'a' },
      { label: 'overLevel', color: '#5b9bd5', stackId: 'a' },
      { label: 'undetermined', color: '#a3afbe', stackId: 'a' },
    ],
    layout: 'vertical',
    parse: parseAnalysisData,
  },
  fisiologicalAgeCalculationAndNumerationNeuropsychologicalModelAnalysis: {
    translation: [
      'dashboard\\ChartInformationProcessing',
      'dashboard\\Publications',
    ],
    translation_ns_parse: { ns: 'dashboard\\Publications' },
    x_axis: [
      {
        label: { value: 'xAxisLabel' },
        type: 'number',
        angle: 0,
      },
    ],
    y_axis: [
      {
        type: 'category',
        width: CHART_VERTICAL_LABEL_WIDTH,
        dataKey: 'subprocess',
      },
      {
        dataKey: 'metaData',
        axisLine: false,
        tickLine: false,
        type: 'category',
        yAxisId: 'process',
        interval: 'preserveStartEnd',
        fontSize: 10,
        tick: tickVerticalGroup,
      },
    ],
    horizontal: false,
    x_keys: [
      { label: 'underLevel', color: '#ffc000', stackId: 'a' },
      { label: 'onLevel', color: '#67c15b', stackId: 'a' },
      { label: 'overLevel', color: '#5b9bd5', stackId: 'a' },
      { label: 'undetermined', color: '#a3afbe', stackId: 'a' },
    ],
    layout: 'vertical',
    parse: parseAnalysisData,
  },
  firstAssignmentArithmeticProblemSolvingCognitiveModelAnalysis: {
    translation: [
      'dashboard\\ChartInformationProcessing',
      'dashboard\\Publications',
    ],
    translation_ns_parse: { ns: 'dashboard\\Publications' },
    x_axis: [
      {
        label: { value: 'xAxisLabel' },
        type: 'number',
        angle: 0,
      },
    ],
    y_axis: [
      {
        type: 'category',
        width: CHART_VERTICAL_LABEL_WIDTH,
        dataKey: 'subprocess',
      },
      {
        dataKey: 'metaData',
        axisLine: false,
        tickLine: false,
        type: 'category',
        yAxisId: 'process',
        interval: 'preserveStartEnd',
        fontSize: 10,
        tick: tickVerticalGroup,
      },
    ],
    horizontal: false,
    x_keys: [
      { label: 'underLevel', color: '#ffc000', stackId: 'a' },
      { label: 'onLevel', color: '#67c15b', stackId: 'a' },
      { label: 'overLevel', color: '#5b9bd5', stackId: 'a' },
      { label: 'undetermined', color: '#a3afbe', stackId: 'a' },
    ],
    layout: 'vertical',
    parse: parseAnalysisData,
  },
  fisiologicalAgeArithmeticProblemSolvingCognitiveModelAnalysis: {
    translation: [
      'dashboard\\ChartInformationProcessing',
      'dashboard\\Publications',
    ],
    translation_ns_parse: { ns: 'dashboard\\Publications' },
    x_axis: [
      {
        label: { value: 'xAxisLabel' },
        type: 'number',
        angle: 0,
      },
    ],
    y_axis: [
      {
        type: 'category',
        width: CHART_VERTICAL_LABEL_WIDTH,
        dataKey: 'subprocess',
      },
      {
        dataKey: 'metaData',
        axisLine: false,
        tickLine: false,
        type: 'category',
        yAxisId: 'process',
        interval: 'preserveStartEnd',
        fontSize: 10,
        tick: tickVerticalGroup,
      },
    ],
    horizontal: false,
    x_keys: [
      { label: 'underLevel', color: '#ffc000', stackId: 'a' },
      { label: 'onLevel', color: '#67c15b', stackId: 'a' },
      { label: 'overLevel', color: '#5b9bd5', stackId: 'a' },
      { label: 'undetermined', color: '#a3afbe', stackId: 'a' },
    ],
    layout: 'vertical',
    parse: parseAnalysisData,
  },
  firstAssignmentGeometryMeasurementAndInformationProcessingAnalysis: {
    translation: [
      'dashboard\\ChartInformationProcessing',
      'dashboard\\Publications',
    ],
    translation_ns_parse: { ns: 'dashboard\\Publications' },
    x_axis: [
      {
        label: { value: 'xAxisLabel' },
        type: 'number',
        angle: 0,
      },
    ],
    y_axis: [
      {
        type: 'category',
        width: CHART_VERTICAL_LABEL_WIDTH,
        dataKey: 'subprocess',
      },
      {
        dataKey: 'metaData',
        axisLine: false,
        tickLine: false,
        type: 'category',
        yAxisId: 'process',
        interval: 'preserveStartEnd',
        fontSize: 10,
        tick: tickVerticalGroup,
      },
    ],
    horizontal: false,
    y_keys: [
      { label: 'underLevel', color: '#ffc000', stackId: 'a' },
      { label: 'onLevel', color: '#67c15b', stackId: 'a' },
      { label: 'overLevel', color: '#5b9bd5', stackId: 'a' },
      { label: 'undetermined', color: '#a3afbe', stackId: 'a' },
    ],
    layout: 'vertical',
    parse: parseAnalysisData,
  },
  fisiologicalAgeGeometryMeasurementAndInformationProcessingAnalysis: {
    translation: [
      'dashboard\\ChartInformationProcessing',
      'dashboard\\Publications',
    ],
    translation_ns_parse: { ns: 'dashboard\\Publications' },
    x_axis: [
      {
        label: { value: 'xAxisLabel' },
        type: 'number',
        angle: 0,
      },
    ],
    y_axis: [
      {
        type: 'category',
        width: CHART_VERTICAL_LABEL_WIDTH,
        dataKey: 'subprocess',
      },
      {
        dataKey: 'metaData',
        axisLine: false,
        tickLine: false,
        type: 'category',
        yAxisId: 'process',
        interval: 'preserveStartEnd',
        fontSize: 10,
        tick: tickVerticalGroup,
      },
    ],
    horizontal: false,
    x_keys: [
      { label: 'underLevel', color: '#ffc000', stackId: 'a' },
      { label: 'onLevel', color: '#67c15b', stackId: 'a' },
      { label: 'overLevel', color: '#5b9bd5', stackId: 'a' },
      { label: 'undetermined', color: '#a3afbe', stackId: 'a' },
    ],
    layout: 'vertical',
    parse: parseAnalysisData,
  },
  fisiologicalAgeMetacognitionAnalysis: {
    translation: 'dashboard\\ChartMetaCognitive',
    x_axis: [
      {
        dataKey: 'question',
        type: 'category',
        angle: -90,
        position: 'bottom',
        textAnchor: 'end',
        fontSize: 10,
        height: 120,
        tickFormatter: (value, t) => {
          return t(value);
        },
      },
      {
        dataKey: 'metaData',
        axisLine: false,
        tickLine: false,
        height: 1,
        scale: 'band',
        xAxisId: 'question',
        tick: (tickProps) => tickHorizontalGroup(tickProps, 120, 0),
      },
    ],
    y_axis: [
      {
        label: { value: 'yAxisLabel' },
      },
    ],
    y_keys: [
      { label: 'overExpertSystem', color: '#ff971e', stackId: 'a' },
      { label: 'sameAsExpertSystem', color: '#29cf84', stackId: 'a' },
      { label: 'underExpertSystem', color: '#ff971e', stackId: 'a' },
    ],
    parse: parseMetacognitiveData,
  },
  firstAssignmentMetacognitionAnalysis: {
    translation: 'dashboard\\ChartMetaCognitive',
    x_axis: [
      {
        dataKey: 'question',
        type: 'category',
        angle: -90,
        position: 'bottom',
        textAnchor: 'end',
        fontSize: 10,
        height: 120,
        tickFormatter: (value, t) => {
          return t(value);
        },
      },
      {
        dataKey: 'metaData',
        axisLine: false,
        tickLine: false,
        height: 1,
        scale: 'band',
        xAxisId: 'question',
        tick: (tickProps) => tickHorizontalGroup(tickProps, 120, 0),
      },
    ],
    y_axis: [
      {
        label: { value: 'yAxisLabel' },
      },
    ],
    y_keys: [
      { label: 'overExpertSystem', color: '#ff971e', stackId: 'a' },
      { label: 'sameAsExpertSystem', color: '#29cf84', stackId: 'a' },
      { label: 'underExpertSystem', color: '#ff971e', stackId: 'a' },
    ],
    parse: parseMetacognitiveData,
  },
};

export const getChartMetadata = (type, currentDateFilter) => {
  const chartClass = CHART_CLASS[type];
  return typeof chartClass === 'function'
    ? chartClass(currentDateFilter)
    : chartClass;
};

export const AGE_WEIGHTS = {
  ageUnder7: 0,
  age7: 1,
  age8: 2,
  age9: 3,
  age10: 4,
  age11: 5,
  age12: 6,
  age13: 7,
  age14: 8,
  age15: 9,
  age16: 10,
  age17: 11,
  ageOver17: 12,
};

export const DATE_FILTER_MIN_DATE = process.env.REACT_APP_START_DATE;

export const CREATE_PARAM = 'create';
export const DEFAULT_PICTURE = '/img/placeholders/avatar_placeholder.png';

export const USER_ROLE_PROJECT = 'USER_ROLE_PROJECT';
export const USER_ROLE_CENTER = 'USER_ROLE_CENTER';

export const USER_GLOBAL_ROLES = [
  { label: 'lblProjectRole', value: USER_ROLE_PROJECT },
  { label: 'lblCenterRole', value: USER_ROLE_CENTER },
];
